const INPUT_SLOT_SELECTOR = '.v-input__slot'

// Vuetify sizes a v-menu to its content, so one long option can push a dropdown past its
// dialog. Capping menu-props.maxWidth at the field's own width is the only lever, and the
// field has to be measured to supply it. undefined reads as uncapped, which is the correct
// state before the first measurement.
export function menuWidthFromEvent (event) {
  return event?.target?.closest(INPUT_SLOT_SELECTOR)?.clientWidth
}
